export default __webpack_public_path__ + "static/media/motion-video.9d01c8b0.mp4";